<div class="field">
  @if (!!_value) {
    <div
      fxlayout="row"
      fxLayoutAlign="space-between center"
      >
      <div>
        <label class="upper">{{ displayName }}</label>
      </div>
    </div>
  }
  @if (showFieldAsEdit) {
    <div
      style="display: block"
      >
      <input
        [(ngModel)]="_value"
        id="{{ fieldUId }}"
        name="{{ fieldUId }}"
        class="input is-small is-fullwidth"
        type="text"
        [placeholder]="displayName" />
    </div>
  }
  @if (!showFieldAsEdit) {
    <div
      style="display: block"
      >
      <div class="is-readonly">{{ valueForDisplay | formatLongText : 100 }}</div>
    </div>
  }
</div>
